<template>
  <order-state-history-item :item="item">
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <v-progress-linear
        v-if="loading"
        indeterminate
      ></v-progress-linear>
      <template v-else>
        <template v-if="isConversationTookPlace">
          <audio-player
            v-if="recordSrc"
            class="mb-3"
            style="width: 100%;"
            :src="recordSrc"
          />
          <!--          <audio-->
          <!--            v-if="recordSrc"-->
          <!--            style="width: 100%;"-->
          <!--            :src="recordSrc"-->
          <!--            controls-->
          <!--          />-->
          <span v-else>Запись недоступна</span>
        </template>
        <span v-else>Разговор не состоялся</span>
      </template>
    </template>
  </order-state-history-item>
</template>

<script>
  import axios from 'axios'
  import OrderStateHistoryItem from '../OrderStateHistoryItem.vue'
  import PhoneCallStatus from '@/models/enums/PhoneCallStatus'
  import AudioPlayer from '@/components/ui/audio-player/AudioPlayer.vue'

  export default {
    name: 'HistoryItemTypeCall',
    components: { OrderStateHistoryItem, AudioPlayer },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        loading: false,
        recordSrc: null,
      }
    },
    computed: {
      title () {
        return 'Звонок' + (this.item.call.callback ? ' исходящий' : ' входящий')
      },
      isConversationTookPlace () {
        return this.item.call.status !== PhoneCallStatus.Canceled
      },
    },
    async created () {
      if (!this.isConversationTookPlace) {
        return
      }

      this.loading = true
      try {
        const response = await axios.get(`/call/${this.item.call.id}/record/url`)
        this.recordSrc = response.data.url
      } catch {} finally {
        this.loading = false
      }
    },
  }
</script>
